import React, { useEffect, useRef, useState } from 'react'
import Hexapi from '../../utility/HexAPI/Hexapi'
import { useSelector } from 'react-redux';
import Meetingheader from './Meetingheader';
import Meetinglist from './Meetinglist';
import Loader from '../../components/loader/Loader';
import "./meeting.css"
import { useMemo } from 'react';
import Meetingdetails from './Meetingdetails';
import Meetinginfo from './Meetinginfo';

const Meetings = () => {

  const user = useSelector(state => state?.users?.data?.[""]?.[0]);
  const userid = user?.empid ?? null;
  const [mode, setmode] = useState(0);
  const [searching, setSearching] = useState(false);
  const [search, setSearch] = useState("");
  const [meetingID, setMeetingID] = useState(null);
  const [detailsloading,setDetailsLoading] = useState(false)
  const [loading, setLoading] = useState(false);
  const [pendingMeetings, setPendingMeetings] = useState([]);
  const [attachments, setAttachments] = useState([]);
  const [closedMeetings, setClosedMeetings] = useState([]);
  const [isInfo,setisInfo] = useState(false)
  const [meetingAction,setmeetingAction] = useState([])
  const [meetingInfo,setmeetingInfo] = useState(null)
  const[details,setDetails] = useState(null)
  const [isAttendee,setisAttendee] = useState([])
const latestModeRef = useRef(mode);
  useEffect(() => {
  latestModeRef.current = mode;
}, [mode]);
  const getMeetingListData = async (ishidden =false) => {
  const currentMode = mode;

  const obj = {
    query: `HRApp_Droid_Proc_User_Meeting_GetList @UserID='{0}', @mode='{1}'`,
    queryArr: [`${userid}`, `${currentMode}`]
  };

  try {
    if(!ishidden){
setLoading(true);
    }
    

    const resp = await Hexapi(obj, () => getMeetingListData(ishidden), 1, 0);

    if (latestModeRef.current !== currentMode) {
      return;
    }

    const data = resp && resp[""] ? resp[""] : [];

    if (currentMode === 0) {
      setPendingMeetings(data);
    } else {
      setClosedMeetings(data);
    }

  } catch (error) {
    console.error("Meeting List Error:", error);
  } finally {
    if (latestModeRef.current === currentMode) {
      setLoading(false);
    }
  }
};
const currentList = mode === 0 ? pendingMeetings : closedMeetings;
const filteredMeetings = useMemo(() => {
  return currentList.filter(item => {
    if (!search.trim()) return true;
    return item?.name?.toLowerCase().includes(search.toLowerCase());
  });
}, [currentList, search]);
  useEffect(() => {
    if (!userid) return;
    console.log("calllegruyfhijdbh")
    getMeetingListData();
  }, [userid, mode]);


  const GetMeetingid = async (id) => {
  setMeetingID(id)
    };


    const getMeetingDetails = async (ishidden = false) => {
      if(meetingID)
      if(!ishidden){
      setmeetingAction([])
      setmeetingInfo(null)
      setDetails(null)
      setDetailsLoading(true)
      }

        const obj = {
            query:`HRApp_Droid_Proc_User_Meeting_Information_GetValueV2 @MeetingID='{0}',@UserID='{1}'`,
            queryArr:[`${meetingID}`,`${userid}`]
        }
        try {
            
            const resp = await Hexapi(obj,()=>getMeetingDetails(),1,0,meetingID)
            console.log(resp,"respsss")

            if(resp && resp.meetinginfo && resp.meetinginfo.length > 0){
                setmeetingInfo(resp.meetinginfo[0])
            }else{
                setmeetingInfo(null)
            }

            if(resp && resp.meetingactions && resp.meetingactions.length > 0){
                setmeetingAction(resp.meetingactions)
            }else{
                setmeetingAction([])
            }

            if(resp && resp[""] && resp[""]){
                setisAttendee(resp[""])

            }else{
                setisAttendee([])
            }

            if(resp && resp.attachments && resp.attachments.length > 0){
              console.log("fghjdkjsl")
                setAttachments(resp.attachments)
            }else{
                setAttachments([])
            }
        } catch (error) {
            console.error("Meeting Details Error:", error);
        } finally {
            setDetailsLoading(false)
        }
    }

    useEffect(()=>{
        if(meetingID && userid){
            getMeetingDetails()
        }
    },[meetingID])
  return (
    <div className='container-fluid mt-3'>
      <div className='row'>
        <div className='col-3'>
          <div className="meeting-header-fixed">
            <Meetingheader
              setmode={setmode}
              mode={mode}
              search={search}
              setSearch={setSearch}
              searching={searching}
              setSearching={setSearching}
            />
          </div>

          <div className="meeting-box mt-2 " >
            {loading ? (
              <div className="d-flex justify-content-center align-items-center"
  style={{ height: "78vh", color: "#ff6d00" }}>
                <Loader />
              </div>
            ) : filteredMeetings.length > 0 ? (
              <Meetinglist list={filteredMeetings}  GetMeetingDetails={(id)=>{GetMeetingid(id)}} meetingid={meetingID}/>
            ) : (
              <div
  className="d-flex justify-content-center align-items-center"
  style={{ height: "78vh", color: "#ff6d00" }}
>
  {search ? "No Search Results Found" : "No Meetings!"}
</div>
            )}
          </div>

        </div>

        <div className={isInfo ? "col-6" : "col-9"} style={{paddingLeft:"0px"}}>
          <div className='meeting-box-right'>
           {
              detailsloading ? <div className="d-flex justify-content-center align-items-center"
  style={{ height: "78vh", color: "#ff6d00" }}>
                <Loader />
              </div> :
            meetingID ? <Meetingdetails attachments={attachments} getMeetingListData={()=>getMeetingListData} GetMeetingDetails={(id)=>{getMeetingDetails(id)}} meetingAction={meetingAction} meetingInfo={meetingInfo} details={details} setisInfo={(data)=>setisInfo(data)} meetingid={meetingID}  userid={userid}/> : <div
  className="d-flex justify-content-center align-items-center"
  style={{ height: "90vh", color: "#ff6d00" }}>
  Select a meeting to view details
</div>
           }
          </div>
        </div>
{
  isInfo && <div className='col-3 meeting-box-right' style={{marginRight:"10px"}}>
<Meetinginfo getMeetingDetails={()=>getMeetingDetails} getMeetingListData={()=>getMeetingListData} userid={userid} setisInfo={(data)=>setisInfo(data)} isAttendee={isAttendee} info={meetingInfo}/>
    </div>
}

      </div>
    </div>
  );
};

export default Meetings;
